module.exports = __webpack_public_path__ + "static/assets/77fde76389422504dfa60c6df6abf6a1.svg";